(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8018],{

/***/ 84151:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"varTextDefault":"var(--tkww-union-color-text-default, var(--tkww-union-color-neutral-black, #000))","varStatusError200":"var(--tkww-union-color-status-error-200, #EB1400)","varStatusInfo300":"var(--tkww-union-color-status-info-300, #114394)","varStatusSuccess200":"var(--tkww-union-color-status-success-200, #008A05)","varStatusWarning200":"var(--tkww-union-color-status-warning-200, #C25400)","varBackgroundError":"var(--tkww-union-color-background-error, var(--tkww-union-color-status-error-100, #FFECE4))","varStatusInfo100":"var(--tkww-union-color-status-info-100, #F4F9FF)","varBackgroundSuccess":"var(--tkww-union-color-background-success, var(--tkww-union-color-status-success-100, #E2FFEE))","varBackgroundWarning":"var(--tkww-union-color-background-warning, var(--tkww-union-color-status-warning-100, #FFF3DD))","varIconSubtle":"var(--tkww-union-color-icon-subtle, var(--tkww-union-color-neutral-500, #51545C))","varLinkDarkOnLight":"var(--tkww-union-color-link-dark-on-light, var(--tkww-union-color-neutral-black, #000))","container":"container--eb861 body1--e44d4","children":"children--c06a3","alert-icon":"alert-icon--c2d73","alertIcon":"alert-icon--c2d73","icon-error":"icon-error--1926b","iconError":"icon-error--1926b","icon-info":"icon-info--86642","iconInfo":"icon-info--86642","icon-success":"icon-success--6c275","iconSuccess":"icon-success--6c275","icon-warning":"icon-warning--d5bb4","iconWarning":"icon-warning--d5bb4","error":"error--357a5","info":"info--e7973","success":"success--c2dba","warning":"warning--57ee7","is-visible":"is-visible--e09ee","isVisible":"is-visible--e09ee","is-not-visible":"is-not-visible--6bd1f","isNotVisible":"is-not-visible--6bd1f","text-container":"text-container--aa77c","textContainer":"text-container--aa77c","alert-cta-container":"alert-cta-container--396bd","alertCtaContainer":"alert-cta-container--396bd","close-button-container":"close-button-container--dd36d","closeButtonContainer":"close-button-container--dd36d","close-button":"close-button--ece31 subhead--150a2","closeButton":"close-button--ece31 subhead--150a2","alert-headline":"alert-headline--57021 body1--e44d4","alertHeadline":"alert-headline--57021 body1--e44d4"};

/***/ }),

/***/ 94355:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only":"sr-only--19d91","srOnly":"sr-only--19d91"};

/***/ }),

/***/ 45173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useAsProp; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70509);
/* harmony import */ var _babel_runtime_corejs3_core_js_array_is_array__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49658);
/* harmony import */ var _babel_runtime_corejs3_core_js_array_is_array__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_array_is_array__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_some__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80945);
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_some__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_instance_some__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_reduce_right__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31529);
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_reduce_right__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_instance_reduce_right__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99084);




/* eslint-disable  import/prefer-default-export */

const isListOfComponents = t => _babel_runtime_corejs3_core_js_array_is_array__WEBPACK_IMPORTED_MODULE_0___default()(t);
const someChangedIdentity = (left, right) => _babel_runtime_corejs3_core_js_instance_some__WEBPACK_IMPORTED_MODULE_1___default()(left).call(left, (el, i) => el !== right[i]);
const createComponentFromAs = as => {
  if (isListOfComponents(as)) {
    const result = _babel_runtime_corejs3_core_js_instance_reduce_right__WEBPACK_IMPORTED_MODULE_2___default()(as).call(as, (Accumulator, LeftComp) => {
      const L = LeftComp;
      const NewComp = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(L, (0,_babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__["default"])({
        as: Accumulator
      }, props));
      return NewComp;
    });
    return result;
  }
  return as;
};
const useAsProp = as => {
  const prevAsValueRef = react__WEBPACK_IMPORTED_MODULE_3__.useRef(as);
  const prevAsValue = prevAsValueRef.current;
  const toRenderRef = react__WEBPACK_IMPORTED_MODULE_3__.useRef(createComponentFromAs(as));
  const arrayChangedSize = _babel_runtime_corejs3_core_js_array_is_array__WEBPACK_IMPORTED_MODULE_0___default()(as) && _babel_runtime_corejs3_core_js_array_is_array__WEBPACK_IMPORTED_MODULE_0___default()(prevAsValue) && (prevAsValue.length !== as.length || someChangedIdentity(prevAsValue, as));
  const propChangedType = _babel_runtime_corejs3_core_js_array_is_array__WEBPACK_IMPORTED_MODULE_0___default()(prevAsValue) !== _babel_runtime_corejs3_core_js_array_is_array__WEBPACK_IMPORTED_MODULE_0___default()(as) && typeof prevAsValue !== typeof as;
  if (arrayChangedSize || propChangedType) {
    toRenderRef.current = createComponentFromAs(as);
  }
  prevAsValueRef.current = as;
  return toRenderRef.current;
};

/***/ }),

/***/ 49237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o5": function() { return /* binding */ InlineAlert; }
});

// UNUSED EXPORTS: InlineAlertCtaButton, InlineAlertCtaLink

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(99084);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-alerts/node_modules/classnames/index.js
var classnames = __webpack_require__(17799);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@xo-union/react-css-modules/lib/index.js
var lib = __webpack_require__(33289);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-alerts/node_modules/@xo-union/tk-component-icons/lib/components/Icon/index.js
var Icon = __webpack_require__(98166);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-alerts/node_modules/@xo-union/tk-component-icons/lib/components/IconButton/index.js + 1 modules
var IconButton = __webpack_require__(59803);
// EXTERNAL MODULE: ./node_modules/@xo-union/react-unique-id/lib/index.js
var react_unique_id_lib = __webpack_require__(79946);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-alerts/lib/components/InlineAlert/styles.css
var styles = __webpack_require__(84151);
var styles_default = /*#__PURE__*/__webpack_require__.n(styles);
// EXTERNAL MODULE: ./node_modules/lodash/capitalize.js
var capitalize = __webpack_require__(37703);
var capitalize_default = /*#__PURE__*/__webpack_require__.n(capitalize);
// EXTERNAL MODULE: ./node_modules/@xo-union/ui-accessibility/lib/ScreenReaderOnly/index.js
var ScreenReaderOnly = __webpack_require__(72944);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-alerts/lib/components/ScreenReaderPrefix.js




const ScreenReaderPrefix = _ref => {
  let {
    type,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement(ScreenReaderOnly/* default */.Z, props, `${capitalize_default()(type)}: `);
};
 false ? 0 : void 0;
/* harmony default export */ var components_ScreenReaderPrefix = (ScreenReaderPrefix);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-alerts/lib/components/InlineAlert/index.js











const defaultIconNames = {
  error: 'error',
  info: 'info',
  success: 'checkmark_circle',
  warning: 'warning'
};
const defaultIconRender = props => /*#__PURE__*/react.createElement(Icon/* default */.Z, props);
const InlineAlertCtaButton = props => /*#__PURE__*/React.createElement(Button, _extends({}, props, {
  color: "primary-alternative",
  size: "sm"
}));
const InlineAlertCtaLink = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Link, _extends({}, props, {
    color: "primary-alternative",
    size: "sm"
  }), children);
};
const InlineAlert = /*#__PURE__*/react.forwardRef((_ref2, ref) => {
  let {
    'aria-live': ariaLive,
    children,
    classes: classesProp,
    className,
    cta,
    headline,
    headlineId,
    icon,
    id,
    onCloseButtonClick,
    role: givenRole,
    type,
    visible
  } = _ref2;
  const classes = (0,lib.useClasses)((styles_default()), classesProp);
  const visibility = visible ? 'is-visible' : 'is-not-visible';
  const visibleClass = classes[visibility] || '';
  const role = visible ? givenRole : 'none';
  const live = visible && role !== 'none' ? ariaLive : 'off';
  const ariaHidden = !visible;
  const visibleCloseButton = onCloseButtonClick !== undefined && type !== 'error';
  const defaultIconName = defaultIconNames[type];
  const iconProps = {
    'aria-hidden': 'true',
    className: classnames_default()(classes['alert-icon'], classes[`icon-${type}`]),
    size: 'md'
  };
  const uniqueHeadlineId = (0,react_unique_id_lib/* useUniqueID */.h)(headlineId);
  return /*#__PURE__*/react.createElement("div", {
    className: classnames_default()(classes.container, classes[type], className, visibleClass),
    role: "group",
    "aria-labelledby": uniqueHeadlineId,
    "aria-hidden": ariaHidden,
    "aria-roledescription": "alert",
    ref: ref,
    id: id
  }, icon !== false && (typeof icon === 'function' ? icon({
    ...iconProps,
    name: defaultIconName
  }) : defaultIconRender({
    ...iconProps,
    name: icon || defaultIconName
  })), /*#__PURE__*/react.createElement("div", {
    className: classes['text-container'],
    role: role,
    "aria-live": live
  }, headline ? /*#__PURE__*/react.createElement("div", {
    role: "heading",
    "aria-level": "1",
    className: classes['alert-headline'],
    id: uniqueHeadlineId
  }, /*#__PURE__*/react.createElement(components_ScreenReaderPrefix, {
    type: type
  }), headline) : /*#__PURE__*/react.createElement(components_ScreenReaderPrefix, {
    id: uniqueHeadlineId,
    type: type
  }), /*#__PURE__*/react.createElement("div", {
    className: classes.children
  }, children), cta && /*#__PURE__*/react.createElement("div", {
    className: classes['alert-cta-container']
  }, cta)), visibleCloseButton && /*#__PURE__*/react.createElement("div", {
    className: classes['close-button-container']
  }, /*#__PURE__*/react.createElement(IconButton/* default */.Z, {
    "aria-label": "close",
    className: classes['close-button'],
    name: "close",
    onClick: onCloseButtonClick,
    size: "md"
  })));
});
 false ? 0 : void 0;
 false ? 0 : void 0;
InlineAlert.defaultProps = {
  'aria-live': 'polite',
  role: 'alert',
  visible: true
};

/***/ }),

/***/ 51665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70509);
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_reduce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86432);
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_reduce__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_instance_reduce__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_corejs3_core_js_object_keys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9938);
/* harmony import */ var _babel_runtime_corejs3_core_js_object_keys__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_object_keys__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_concat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33028);
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_concat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_instance_concat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99084);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4370);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _xo_union_tk_css_grid_lib_styles_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1640);
/* harmony import */ var _xo_union_tk_css_grid_lib_styles_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_xo_union_tk_css_grid_lib_styles_css__WEBPACK_IMPORTED_MODULE_5__);








const getGridSizeClasses = breakpoints => {
  var _context;
  return _babel_runtime_corejs3_core_js_instance_reduce__WEBPACK_IMPORTED_MODULE_0___default()(_context = _babel_runtime_corejs3_core_js_object_keys__WEBPACK_IMPORTED_MODULE_1___default()(breakpoints)).call(_context, (classes, key) => {
    if (!breakpoints[key]) {
      return classes;
    }
    const sizeSuffix = breakpoints[key] === true ? '' : `-${breakpoints[key]}`;
    const breakpointInfix = key === 'xs' ? '' : `-${key}`;
    return classnames__WEBPACK_IMPORTED_MODULE_4___default()(classes, (_xo_union_tk_css_grid_lib_styles_css__WEBPACK_IMPORTED_MODULE_5___default())[`col${breakpointInfix}${sizeSuffix}`]);
  }, '');
};
const getGridOrderClass = orderBreakpoints => {
  var _context2;
  return _babel_runtime_corejs3_core_js_instance_reduce__WEBPACK_IMPORTED_MODULE_0___default()(_context2 = _babel_runtime_corejs3_core_js_object_keys__WEBPACK_IMPORTED_MODULE_1___default()(orderBreakpoints)).call(_context2, (classes, key) => {
    if (!orderBreakpoints[key]) {
      return classes;
    }
    const [, breakpoint] = key.match(/order(..)?$/);
    const breakpointInfix = breakpoint ? `-${breakpoint.toLowerCase()}` : '';
    const valueSuffix = `-${orderBreakpoints[key]}`;
    return classnames__WEBPACK_IMPORTED_MODULE_4___default()(classes, (_xo_union_tk_css_grid_lib_styles_css__WEBPACK_IMPORTED_MODULE_5___default())[`order${breakpointInfix}${valueSuffix}`]);
  }, '');
};
const Column = _ref => {
  let {
    xs,
    sm,
    md,
    lg,
    xl,
    xxl,
    order,
    orderSm,
    orderMd,
    orderLg,
    orderXl,
    orderXxl,
    children,
    className,
    as: ComponentToRender,
    ...props
  } = _ref;
  const classes = [getGridOrderClass({
    order,
    orderSm,
    orderMd,
    orderLg,
    orderXl,
    orderXxl
  }), getGridSizeClasses({
    xs,
    sm,
    md,
    lg,
    xl,
    xxl
  }), className];
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(ComponentToRender, (0,_babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__["default"])({
    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(classes)
  }, props), children);
};
const allowedColumnValues =  false ? 0 : {};
const columnNumberPropType =  false ? 0 : {};
const allowedColumnSizeProps =  false ? 0 : {};
const columnSizePropType =  false ? 0 : {};
 false ? 0 : void 0;
Column.defaultProps = {
  className: '',
  as: 'div'
};
/* harmony default export */ __webpack_exports__["Z"] = (Column);

/***/ }),

/***/ 19766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70509);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99084);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4370);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _xo_union_react_css_modules__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33289);
/* harmony import */ var _xo_union_tk_css_grid_lib_styles_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1640);
/* harmony import */ var _xo_union_tk_css_grid_lib_styles_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_xo_union_tk_css_grid_lib_styles_css__WEBPACK_IMPORTED_MODULE_3__);







const Row = _ref => {
  let {
    as: ComponentToRender,
    children,
    className,
    classes: classesProp,
    hAlign,
    hGutters,
    noGutters,
    vAlign,
    vGutters,
    ...props
  } = _ref;
  const classes = (0,_xo_union_react_css_modules__WEBPACK_IMPORTED_MODULE_2__.useClasses)((_xo_union_tk_css_grid_lib_styles_css__WEBPACK_IMPORTED_MODULE_3___default()), classesProp);
  const containerClass = classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, classes.row, hAlign && (_xo_union_tk_css_grid_lib_styles_css__WEBPACK_IMPORTED_MODULE_3___default())[`justify-content-${hAlign}`], vAlign && (_xo_union_tk_css_grid_lib_styles_css__WEBPACK_IMPORTED_MODULE_3___default())[`align-items-${vAlign}`], {
    [(_xo_union_tk_css_grid_lib_styles_css__WEBPACK_IMPORTED_MODULE_3___default()["no-gutters"])]: hGutters === false || noGutters
  }, {
    [(_xo_union_tk_css_grid_lib_styles_css__WEBPACK_IMPORTED_MODULE_3___default()["vertical-gutters"])]: vGutters
  });
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ComponentToRender, (0,_babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__["default"])({
    className: containerClass
  }, props), children);
};
Row.defaultProps = {
  as: 'div',
  hGutters: true,
  noGutters: false,
  vGutters: false,
  className: ''
};
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (Row);

/***/ }),

/***/ 72944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70509);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99084);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62513);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _xo_union_react_polymorphic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45173);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94355);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_css__WEBPACK_IMPORTED_MODULE_4__);







/**
 * Wrap content that should only be visible to screen readers.
 *
 * ref is forwarded to underlying element
 *
 *
 * ### When to use `ScreenReaderOnly` instead of `aria-label`
 *
 * Use this component when the screen-reader content is a superset of the visual content or in
 * cases where the existing HTML is complex (hierarchically) but is mostly correct when read out
 * loud by a screen-reader -- In this case `ScreenReaderOnly` should only enhance the information
 * that is already present in the DOM. In this scenario `ScreenReaderOnly` will also help you avoid
 * duplication of HTML text (that may be rendered in separate HTML nodes) on `aria-label`
 * properties.
 *
 */
const ScreenReaderOnly = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_ref, ref) => {
  let {
    as,
    className,
    ...props
  } = _ref;
  const ComponentToRender = (0,_xo_union_react_polymorphic__WEBPACK_IMPORTED_MODULE_2__/* .useAsProp */ .R)(as);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ComponentToRender, (0,_babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__["default"])({
    ref: ref,
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_styles_css__WEBPACK_IMPORTED_MODULE_4___default()["sr-only"]), className)
  }, props));
});
 false ? 0 : void 0;
ScreenReaderOnly.defaultProps = {
  as: 'span'
};
/* harmony default export */ __webpack_exports__["Z"] = (ScreenReaderOnly);

/***/ }),

/***/ 63938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ Input; },
  "Z": function() { return /* binding */ lib_Form; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/helpers/esm/extends.js
var esm_extends = __webpack_require__(70509);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/set-timeout.js
var set_timeout = __webpack_require__(79021);
var set_timeout_default = /*#__PURE__*/__webpack_require__.n(set_timeout);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/instance/for-each.js
var for_each = __webpack_require__(28301);
var for_each_default = /*#__PURE__*/__webpack_require__.n(for_each);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/object/assign.js
var object_assign = __webpack_require__(54420);
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/array/is-array.js
var is_array = __webpack_require__(49658);
var is_array_default = /*#__PURE__*/__webpack_require__.n(is_array);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/set.js
var set = __webpack_require__(39015);
var set_default = /*#__PURE__*/__webpack_require__.n(set);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/instance/every.js
var every = __webpack_require__(33160);
var every_default = /*#__PURE__*/__webpack_require__.n(every);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/instance/find.js
var find = __webpack_require__(89189);
var find_default = /*#__PURE__*/__webpack_require__.n(find);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/instance/flat-map.js
var flat_map = __webpack_require__(99697);
var flat_map_default = /*#__PURE__*/__webpack_require__.n(flat_map);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(99084);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(61820);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/lodash/noop.js
var noop = __webpack_require__(21818);
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-form-validations/lib/formValidators/index.js
const required = () => ({
  name: 'required',
  staticProps: {
    'aria-required': 'true'
  },
  validate: function (fieldName) {
    let value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    if (value) {
      return null;
    }
    return `${fieldName} is required.`;
  }
});

// Taken from here: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/email#basic_validation
const emailPattern =
// eslint-disable-next-line max-len
/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
const email = () => ({
  name: 'email',
  staticProps: {
    /* autocomplete: 'email' ???? */
    /* Other than aria props it may not make sense to set anything else here
      in cases where this is used in non `input` elements
    */
  },
  validate: function (fieldName) {
    let value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    if (value && !emailPattern.test(value)) {
      return 'Must be a valid email.';
    }
    return null;
  }
});
const minLength = min => ({
  name: 'minLength',
  staticProps: {},
  validate: function (fieldName) {
    let value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    if (value && value.length < min) {
      return `${fieldName} must be at least ${min} characters.`;
    }
    return null;
  }
});
const maxLength = max => ({
  name: 'maxLength',
  staticProps: {},
  validate: function (fieldName) {
    let value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    if (value && value.length > max) {
      return `${fieldName} must be less than or equal to ${max} characters.`;
    }
    return null;
  }
});
const pattern = function (regExp) {
  let patternMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : regExp;
  let message = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return {
    name: 'pattern',
    staticProps: {},
    validate: function (fieldName) {
      let value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      if (value && !regExp.test(value)) {
        if (message) {
          return message;
        }
        return `${fieldName} must match pattern ${patternMsg}.`;
      }
      return null;
    }
  };
};
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-form-validations/lib/createErrors/index.js

const humanize = string => {
  const [[firstChar, ...rest], ...words] = string.split(/[\W\s]/g);
  const capitalizedFirstWord = [firstChar.toUpperCase(), ...rest].join('');
  return [capitalizedFirstWord, ...words].join(' ');
};
const normalizeFieldName = name => name ? humanize(name) : 'Field';
const createErrors = function (property, value) {
  let validators = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  const errors = [];
  for_each_default()(validators).call(validators, validator => {
    const result = validator.validate(normalizeFieldName(property), value);
    if (result) {
      errors.push({
        name: validator.name,
        data: result
      });
    }
    errors[validator.name] = result;
  });
  return errors;
};
/* harmony default export */ var lib_createErrors = (createErrors);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-form-validations/lib/Form/index.js














const schedulePreventable = callback => {
  const timeoutId = set_timeout_default()(() => {
    callback();
  });
  return () => {
    clearTimeout(timeoutId);
  };
};
const getStaticPropsFromValidators = validators => {
  const props = {};
  for_each_default()(validators).call(validators, validator => {
    assign_default()(props, validator.staticProps || {});
  });
  return props;
};
const maybeCallFunction = function (prop) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return typeof prop === 'function' ? prop(...args) : prop;
};
const defaultSubTextOnInvalid = _ref => {
  let {
    errors
  } = _ref;
  return errors[0].data;
};
const Context = /*#__PURE__*/react.createContext({
  bindField: (noop_default()),
  unbindField: (noop_default())
});
const useRenderRef = val => {
  const ref = react.useRef(val);
  ref.current = val;
  return ref;
};
const normalizePatternArgs = patternParam => {
  let args;
  if (is_array_default()(patternParam)) {
    args = patternParam;
  } else if (typeof patternParam === 'object' && !(patternParam instanceof RegExp)) {
    args = [patternParam.test, patternParam.patternName, patternParam.message];
  } else {
    args = [patternParam];
  }
  return args;
};
const Form = /*#__PURE__*/react.forwardRef((_ref2, ref) => {
  let {
    onSubmit = (noop_default()),
    children,
    ...restOfProps
  } = _ref2;
  const fieldBindingsRef = react.useRef(new (set_default())());
  const bindField = binding => {
    fieldBindingsRef.current.add(binding);
  };
  const unbindField = binding => {
    fieldBindingsRef.current.delete(binding);
  };
  const handleLeavingOfAllFields = () => {
    var _context;
    for_each_default()(_context = fieldBindingsRef.current).call(_context, fieldBinding => {
      fieldBinding.handleErrorsOnLeave();
    });
  };
  const handleSubmit = evt => {
    var _context2;
    /**
     * Prevent default needs to be the very first thing. See note #1 above.
     */
    evt.preventDefault();
    const valid = every_default()(_context2 = [...fieldBindingsRef.current]).call(_context2, _ref3 => {
      let {
        errorsRef
      } = _ref3;
      return errorsRef.current.length === 0;
    });
    const validate = () => {
      if (!valid) {
        var _context3;
        handleLeavingOfAllFields();
        const firstFocusableFieldWithErrorsBinding = find_default()(_context3 = [...fieldBindingsRef.current]).call(_context3, _ref4 => {
          let {
            errorsRef,
            elementRef
          } = _ref4;
          return errorsRef.current.length > 0 && elementRef.current;
        });
        if (firstFocusableFieldWithErrorsBinding) {
          firstFocusableFieldWithErrorsBinding.elementRef.current.focus();
        }
      }
    };
    const preventValidation = schedulePreventable(validate);
    const pseudoEvent = {
      valid,
      validate,
      preventValidation
    };
    onSubmit(pseudoEvent, evt);
  };
  const context = {
    bindField,
    unbindField
  };
  return /*#__PURE__*/react.createElement(Context.Provider, {
    value: context
  }, /*#__PURE__*/react.createElement("form", (0,esm_extends["default"])({
    ref: ref,
    noValidate: true,
    onSubmit: handleSubmit
  }, restOfProps), children));
});
 false ? 0 : void 0;
const useInput = _ref5 => {
  let {
    defaultValue,
    value,
    name,
    validations,
    ref,
    onChange: givenOnChange = (noop_default()),
    onBlur: givenOnBlur = (noop_default()),
    subText = '',
    subTextOnValid = subText,
    subTextOnInvalid = defaultSubTextOnInvalid
  } = _ref5;
  const [visualState, setVisualState] = react.useState('neutral');
  const visualStateRef = useRenderRef(visualState);
  const fallbackRef = react.useRef();
  const errorsRef = react.useRef([]);
  const finalElementRef = ref || fallbackRef;
  const isValueControlledRef = react.useRef(value !== undefined);
  let onChange = givenOnChange;
  let controlledOrUncontrolledValue;
  const handleErrorsOnChange = () => {
    if (visualStateRef.current === 'invalid' && errorsRef.current.length === 0) {
      setVisualState('valid');
    } else if (visualStateRef.current === 'valid' && errorsRef.current.length > 0) {
      setVisualState('invalid');
    }
  };
  const handleErrorsOnLeave = react.useCallback(() => {
    if (errorsRef.current.length > 0) {
      setVisualState('invalid');
    } else {
      setVisualState('neutral');
    }
  }, []);
  if (isValueControlledRef.current) {
    controlledOrUncontrolledValue = value;
  } else {
    /*
      Conditional call of react hooks is generally unsafe but
      it is completely safe here because it is dependent on a ref
      value that never changes
    */
    /* eslint-disable react-hooks/rules-of-hooks */
    const [uncontrolledValue, setUncontrolledValue] = react.useState(defaultValue);
    controlledOrUncontrolledValue = uncontrolledValue;
    onChange = react.useCallback(evt => {
      setUncontrolledValue(evt.target.value);
      givenOnChange(evt);
    }, [givenOnChange]);
  }
  errorsRef.current = lib_createErrors(name, controlledOrUncontrolledValue, validations);
  handleErrorsOnChange();
  const onBlur = react.useCallback(evt => {
    if (!evt.currentTarget.contains(evt.relatedTarget)) {
      handleErrorsOnLeave();
    }
    givenOnBlur(evt);
  }, [handleErrorsOnLeave, givenOnBlur]);
  const finalProps = {
    ref: finalElementRef,
    defaultValue,
    value,
    name,
    'aria-invalid': visualState === 'invalid' ? 'true' : undefined,
    onBlur,
    onChange,
    ...getStaticPropsFromValidators(validations)
  };
  const form = react.useContext(Context);
  const formRef = useRenderRef(form);
  react.useEffect(() => {
    const formBinding = {
      errorsRef,
      elementRef: finalElementRef,
      handleErrorsOnLeave
    };
    const dereferencedForm = formRef.current;
    dereferencedForm.bindField(formBinding);
    return () => dereferencedForm.unbindField(formBinding);
  }, [finalElementRef, formRef, handleErrorsOnLeave]);
  const getSubtext = () => {
    const errors = errorsRef.current;
    if (visualState === 'valid' && errors.length === 0) {
      return maybeCallFunction(subTextOnValid, {}, subText);
    }
    if (visualState === 'invalid' && errors.length > 0) {
      return maybeCallFunction(subTextOnInvalid, {
        errors
      }, defaultSubTextOnInvalid({
        errors
      }));
    }
    return maybeCallFunction(subText, {
      errors
    }, '');
  };
  return [finalProps, {
    errors: errorsRef.current,
    state: visualState,
    subText: getSubtext()
  }];
};
const Input = /*#__PURE__*/react.forwardRef((_ref6, ref) => {
  let {
    name,
    value,
    defaultValue,
    validations,
    children,
    onBlur,
    onChange,
    subText,
    subTextOnValid,
    subTextOnInvalid,
    /** No validation only props */
    state
  } = _ref6;
  const validationsAreBeingUsed = !!validations;
  const validationsEnabledRef = react.useRef(validationsAreBeingUsed);
  if (!validationsEnabledRef.current) {
    if (validationsAreBeingUsed) {
       false ? 0 : void 0;
    }
    if (subTextOnValid || subTextOnInvalid) {
       false ? 0 : void 0;
    }
    return children({
      onChange,
      onBlur,
      name,
      ref,
      value,
      defaultValue
    }, {
      state,
      subText,
      errors: []
    });
  }
  if (state) {
     false ? 0 : void 0;
  }
  if (!validationsAreBeingUsed) {
     false ? 0 : void 0;
  }
  const finalValidations = react.useMemo(() => {
    const validationsFromConvenienceProp = validationValue => {
      const validationList = [];
      if (validationValue.required === true) {
        validationList.push(required());
      }
      if (validationValue.email === true) {
        validationList.push(email());
      }
      if (typeof validationValue.pattern !== 'undefined') {
        const args = normalizePatternArgs(validationValue.pattern);
        validationList.push(pattern(...args));
      }
      if (typeof validationValue.minLength === 'number') {
        validationList.push(minLength(validationValue.minLength));
      }
      if (typeof validationValue.maxLength === 'number') {
        validationList.push(maxLength(validationValue.maxLength));
      }
      return validationList;
    };
    const givenValidations = validations || [];
    const normalizedGivenValidations = is_array_default()(givenValidations) ? givenValidations : [givenValidations];
    return flat_map_default()(normalizedGivenValidations).call(normalizedGivenValidations, validation => {
      if (typeof validation.validate === 'function') {
        return validation;
      }
      return validationsFromConvenienceProp(validation);
    });
  }, [validations]);
  const [props, data] = useInput({
    ref,
    name,
    value,
    defaultValue,
    validations: finalValidations,
    onBlur,
    onChange,
    subText,
    subTextOnValid,
    subTextOnInvalid
  });
  return children(props, data);
});
const tupleType = typeCheckers => prop_types_default().arrayOf(function (value, index) {
  for (var _len2 = arguments.length, rest = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    rest[_key2 - 2] = arguments[_key2];
  }
  return typeCheckers[index].call((prop_types_default()), value, index, ...rest);
});
Input.propTypes = {
  /**
   * Field name
   */
  name: (prop_types_default()).string,
  /**
   * Value of input if you wish to enable controlled mode
   */
  value: (prop_types_default()).string,
  /**
   * Default value for uncontrolled mode
   */
  defaultValue: (prop_types_default()).string,
  /**
   * Validations to apply
   */
  validations: prop_types_default().oneOfType([prop_types_default().shape({
    required: (prop_types_default()).bool,
    email: (prop_types_default()).bool,
    minLength: (prop_types_default()).number,
    maxLength: (prop_types_default()).number,
    pattern: prop_types_default().oneOfType([tupleType([prop_types_default().shape({
      test: (prop_types_default()).func
    }), (prop_types_default()).string]), prop_types_default().shape({
      test: (prop_types_default()).func
    }), prop_types_default().shape({
      test: prop_types_default().shape({
        test: (prop_types_default()).func
      }),
      patternName: (prop_types_default()).string,
      message: (prop_types_default()).string
    })])
  }), prop_types_default().shape({
    staticProps: prop_types_default().shape(),
    name: (prop_types_default()).string.isRequired,
    validate: (prop_types_default()).func.isRequired
  }), prop_types_default().arrayOf(prop_types_default().oneOfType([prop_types_default().shape({
    required: (prop_types_default()).bool,
    email: (prop_types_default()).bool,
    minLength: (prop_types_default()).number,
    maxLength: (prop_types_default()).number,
    pattern: prop_types_default().oneOfType([tupleType([prop_types_default().shape({
      test: (prop_types_default()).func
    }), (prop_types_default()).string]), prop_types_default().shape({
      test: (prop_types_default()).func
    })])
  }), prop_types_default().shape({
    staticProps: prop_types_default().shape(),
    name: (prop_types_default()).string.isRequired,
    validate: (prop_types_default()).func.isRequired
  })]))]),
  /**
   * Called on blur. Merged with onBlur provided by this component
   */
  onBlur: (prop_types_default()).func,
  /**
   * Called on change. Merged with onChange provided by this component
   */
  onChange: (prop_types_default()).func,
  /**
   * Sub text to render.
   * This is some generic messaging that the rendered component chooses how it should be rendered.
   * This is used when the visual state is `neutral` or when the visual state is `valid` and a
   * subTextOnValid was not provided. When a function is provided, current errors are passed to it.
   */
  subText: prop_types_default().oneOfType([(prop_types_default()).node, (prop_types_default()).func]),
  /**
   * Sub text to render when visual state is valid.
   */
  subTextOnValid: prop_types_default().oneOfType([(prop_types_default()).node, (prop_types_default()).func]),
  /**
   * Sub text to render when visual state is invalid. Defaults to rendering the first error.
   */
  subTextOnInvalid: prop_types_default().oneOfType([(prop_types_default()).node, (prop_types_default()).func]),
  /**
   * Render function. Receives the generated props and the error state.
   *
   * ```
   * (nativeProps, { errors, state }) => React.node
   * ```
   */
  children: (prop_types_default()).func.isRequired,
  /**
   * Force the state. Will only be used if validations are disabled.
   */
  state: prop_types_default().oneOf(['valid', 'invalid', 'neutral'])
};
/* harmony default export */ var lib_Form = (Form);

/***/ }),

/***/ 74375:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(6165);

module.exports = parent;


/***/ }),

/***/ 1609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(84078);

module.exports = parent;


/***/ }),

/***/ 75436:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(13982);

module.exports = parent;


/***/ }),

/***/ 36292:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(48445);
var entryVirtual = __webpack_require__(65974);

module.exports = entryVirtual('Array').concat;


/***/ }),

/***/ 81395:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(82195);
var entryVirtual = __webpack_require__(65974);

module.exports = entryVirtual('Array').every;


/***/ }),

/***/ 294:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(36626);
var entryVirtual = __webpack_require__(65974);

module.exports = entryVirtual('Array').reduceRight;


/***/ }),

/***/ 16663:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototypeOf = __webpack_require__(59433);
var method = __webpack_require__(36292);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.concat;
  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.concat) ? method : own;
};


/***/ }),

/***/ 30958:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototypeOf = __webpack_require__(59433);
var method = __webpack_require__(81395);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.every;
  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.every) ? method : own;
};


/***/ }),

/***/ 41186:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototypeOf = __webpack_require__(59433);
var method = __webpack_require__(294);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.reduceRight;
  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.reduceRight) ? method : own;
};


/***/ }),

/***/ 37156:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(45164);


/***/ }),

/***/ 94182:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(87244);


/***/ }),

/***/ 18471:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(99719);


/***/ }),

/***/ 45164:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(74375);

module.exports = parent;


/***/ }),

/***/ 87244:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(1609);

module.exports = parent;


/***/ }),

/***/ 99719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(75436);

module.exports = parent;


/***/ }),

/***/ 82195:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var $every = (__webpack_require__(16918).every);
var arrayMethodIsStrict = __webpack_require__(15419);

var STRICT_METHOD = arrayMethodIsStrict('every');

// `Array.prototype.every` method
// https://tc39.es/ecma262/#sec-array.prototype.every
$({ target: 'Array', proto: true, forced: !STRICT_METHOD }, {
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 36626:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var $reduceRight = (__webpack_require__(72312).right);
var arrayMethodIsStrict = __webpack_require__(15419);
var CHROME_VERSION = __webpack_require__(59483);
var IS_NODE = __webpack_require__(5900);

// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
var FORCED = CHROME_BUG || !arrayMethodIsStrict('reduceRight');

// `Array.prototype.reduceRight` method
// https://tc39.es/ecma262/#sec-array.prototype.reduceright
$({ target: 'Array', proto: true, forced: FORCED }, {
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduceRight(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 6165:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(16663);

module.exports = parent;


/***/ }),

/***/ 84078:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(30958);

module.exports = parent;


/***/ }),

/***/ 13982:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(41186);

module.exports = parent;


/***/ }),

/***/ 8788:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createCompounder = __webpack_require__(3087);

/**
 * Converts `string`, as space separated words, to lower case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the lower cased string.
 * @example
 *
 * _.lowerCase('--Foo-Bar--');
 * // => 'foo bar'
 *
 * _.lowerCase('fooBar');
 * // => 'foo bar'
 *
 * _.lowerCase('__FOO_BAR__');
 * // => 'foo bar'
 */
var lowerCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + word.toLowerCase();
});

module.exports = lowerCase;


/***/ }),

/***/ 49658:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(81463);

/***/ }),

/***/ 33028:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(37156);

/***/ }),

/***/ 33160:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(94182);

/***/ }),

/***/ 31529:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(18471);

/***/ }),

/***/ 39015:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(7558);

/***/ }),

/***/ 17799:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 4370:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 62513:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ })

}]);